import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {connect, store} from 'react-redux'
import {Link, withRouter} from 'react-router-dom';
import * as GlobalConfig from 'constants/GlobalConfig';
import {Breadcrumb, Icon, Button} from 'antd';
import log from 'components/utils/Logger';
import moment from 'moment'
import "moment/locale/ja";
import IntervalTimer from "../../components/utils/IntervalTimer";


const mapStateToProps = (state, props) => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changeLanguage: (langCode) => {
        }
    }
};

/**
 * コンテンツヘッダ
 */
class Header extends Component {
    constructor(props) {
        super(props);
        this.state= {
            day: moment().format('MM月DD日（ddd)'),
            time: moment().format('HH:mm')
        }
    };

    componentWillReceiveProps(nextProps) {
        log.debug(nextProps);
    };

    render() {
        return (
            <header>
                <div id={"header-body"}>
                    {this.props.logo ?
                        <div id="header-logo">
                            <img id="header-logo-img" src={GlobalConfig.Logo} alt="Ist-Reserve"/>
                        </div>
                        :
                        undefined
                    }
                    <div id={"header-title"} >
                        {this.props.title}
                    </div>
                    <div id="header-action">
                        {this.props.headerAction}
                    </div>
                </div>
                <div id="header-time">
                    <div id="header-time-day">{this.state.day}</div>
                    <div id="header-time-hour">{this.state.time}</div>
                </div>
                <IntervalTimer
                    enabled={true}
                    callback={() => {
                        this.setState({
                            day: moment().format('MM月DD日（ddd)'),
                            time: moment().format('HH:mm')
                        })
                     }}
                    timeout={1000}
                />
            </header>
        )
    };
}

Header.propTypes = {
    title: PropTypes.object || PropTypes.string,
    headerAction: PropTypes.object,
    langChangeable: PropTypes.bool
};

Header.defaultProps = {
    title: "",
    headerAction: null,
    langChangeable: false,
    logo: false
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)



// WEBPACK FOOTER //
// ./src/containers/header/Header.js